var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"t-menu",class:{'t-menu-horizontal':_vm.mode==='horizontal'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }